import React from 'react';
import ModernNavbar from '../components/navigation/ModernNavbar';
import FloatingActionButton from '../components/common/FloatingActionButton';
import Hero from '../components/Hero';
import QuestionnaireSection from '../components/QuestionnaireSection';
import Features from '../components/Features';
import Problems from '../components/problems/Problems';
import HowItWorks from '../components/HowItWorks';
import ExampleReportSection from '../components/ExampleReportSection';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';
import EarlyAccessBand from '../components/EarlyAccessBand';

export default function HomePage() {
  const handleGetStarted = () => {
    const objectiveSection = document.getElementById('objective-selector');
    if (objectiveSection) {
      objectiveSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      objectiveSection.focus();
    }
  };

  return (
    <div className="min-h-screen bg-dark">
      <ModernNavbar onGetStarted={handleGetStarted} />
      <Hero onGetStarted={handleGetStarted} />
      <Problems />
      <QuestionnaireSection />
      <Features />
      <HowItWorks />
      <ExampleReportSection />
      <Pricing />
      <Footer />
{/*      <EarlyAccessBand /> */}
      <FloatingActionButton />
    </div>
  );
}